    <!-- Back To Top -->
    <div class="scrollToTop" (click)="taptotop()"
    [ngStyle]="{ display: show ? 'block' : 'none' }"
    style="display: flex">
        <span class="arrow"><i class="ri-arrow-up-s-fill text-xl leading-loose"></i></span>
    </div>